import { Entity } from '@debbie/common/dist/index.js';
import { getPropertyFilterType } from '@debbie/common/dist/insights/property-filter.js';
import { caseGroupScopeIds, } from '@debbie/common/dist/properties/index.js';
import { cancelDebounce, debounce } from '@debbie/common/dist/util/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Input } from '../../index.js';
import PropertyTypeSelect from '../../PropertyTypeSelect.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const supportsPropertyFilter = (propertyType) => propertyType.ref !== Entity.Creditor;
const PropertiesGroup = (props) => {
    const lang = useSelector((s) => s.lang);
    const { caseFilter } = props;
    const [selection, setSelection] = useState(caseFilter.property ?? null);
    const [value, setValue] = useState(props.caseFilter.property?.value ?? '');
    const [commaSeparated, setCommaSeparated] = useState(props.caseFilter.property?.commaSeparated ?? true);
    const propertyTypes = usePropertyTypes();
    const propertyType = h.hasData(propertyTypes)
        ? getPropertyFilterType(propertyTypes.data, selection)
        : undefined;
    const pendingUpdate = useRef(null);
    useEffect(() => () => pendingUpdate.current?.(), []);
    const setFilter = (selected, options = {}) => {
        cancelDebounce('properties-filter-search');
        pendingUpdate.current = null;
        if (selected === null) {
            setValue('');
        }
        const nextValue = options.value ?? value;
        if (selected && nextValue !== '') {
            caseFilterStore.updateFilter({
                property: {
                    ...selected,
                    value: nextValue,
                    commaSeparated: options.commaSeparated ?? commaSeparated,
                },
            });
        }
        else {
            caseFilterStore.clearFilter('property');
        }
    };
    return (React.createElement(FilterGroup, { name: lang.caseFilter.properties },
        React.createElement(FilterOption, { active: !!caseFilter.property, header: lang.caseFilter.property, subheader: lang.caseFilter.propertyExplanation, onDeactivate: () => {
                setSelection(null);
                setFilter(null);
            } },
            React.createElement(PropertyTypeSelect, { value: propertyType?.propertyTypeId ?? null, filter: supportsPropertyFilter, onChange: (_id, type) => {
                    const selected = type
                        ? {
                            scope: null,
                            scopeIds: caseGroupScopeIds(type.scopes),
                            propertyTypeId: type.propertyTypeId,
                            referenceType: type.ref,
                            handle: type.handle,
                        }
                        : null;
                    setSelection(selected);
                    setFilter(selected);
                } }),
            selection && (React.createElement(React.Fragment, null,
                React.createElement(Input, { placeholder: lang.misc.value, value: value, onChange: (e) => {
                        let val = e.currentTarget.value;
                        setValue(val);
                        const update = () => setFilter(selection, { value: val });
                        pendingUpdate.current = update;
                        debounce('properties-filter-search', update, 750);
                    } }),
                React.createElement(Checkbox, { checked: commaSeparated, onChange: (e) => {
                        setCommaSeparated(e.currentTarget.checked);
                        setFilter(selection, {
                            commaSeparated: e.currentTarget.checked,
                        });
                    }, placeholder: 'Komma separerede værdier' }))))));
};
export default PropertiesGroup;
//# sourceMappingURL=PropertiesGroup.js.map